import { render, staticRenderFns } from "./ResourcesEditor.vue?vue&type=template&id=20cb1586&scoped=true"
import script from "./ResourcesEditor.vue?vue&type=script&lang=js"
export * from "./ResourcesEditor.vue?vue&type=script&lang=js"
import style0 from "./ResourcesEditor.vue?vue&type=style&index=0&id=20cb1586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cb1586",
  null
  
)

export default component.exports